<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2023 (original work) Open Assessment Technologies SA ;

    import Flyout from '../flyout/Flyout.svelte';

    export let categories = [];

    let root;
    let flyoutVisible = false;

    $: visibleCategories = categories.filter(item => item.count > 0);
    $: totalCount = visibleCategories.reduce((accumulator, item) => accumulator + item.count, 0);
    $: gridColumns = visibleCategories.map(item => Math.ceil((item.count / totalCount) * 100));

    function showFlyout() {
        flyoutVisible = true;
    }

    function hideFlyout() {
        setTimeout(() => {
            flyoutVisible = false;
        }, 0);
    }

    function renderStyleString(style) {
        return style ?? '';
    }
</script>

<style>
    .distribution-root {
        display: grid;
    }

    .category {
        grid-column-end: span var(--count);
        padding-inline-start: var(--space-1x);
        padding-inline-end: var(--space-1x);
    }

    .flyout-content {
        padding: var(--space-2x);
        display: grid;
        gap: var(--space-2x);
        grid-template-columns: var(--space-9x) auto;
    }

    .flyout-category-count {
        padding-inline-start: var(--space-1x);
        padding-inline-end: var(--space-1x);
    }
</style>

<!-- svelte-ignore a11y-no-noninteractive-tabindex -->
<div
    class="distribution-root"
    tabindex="0"
    style={`grid-template-columns: ${gridColumns.map(column => `minmax(max-content, ${column}%)`).join(' ')}`}
    bind:this={root}
    on:focus={showFlyout}
    on:blur={hideFlyout}
    on:mouseenter={showFlyout}
    on:mouseleave={hideFlyout}>
    {#each visibleCategories as { count, style }}
        <div class="category" style={renderStyleString(style)}>
            {count}
        </div>
    {/each}
</div>
<Flyout isOpen={flyoutVisible} reference={root}>
    <div class="flyout-content">
        {#each categories as { label, count, style }}
            <div class="flyout-category-count" style={renderStyleString(style)}>{count}</div>
            <div>{label}</div>
        {/each}
    </div>
</Flyout>
